import { render } from "./diyDemandModel.vue?vue&type=template&id=1f3355c0"
import script from "./diyDemandModel.vue?vue&type=script&lang=js"
export * from "./diyDemandModel.vue?vue&type=script&lang=js"

import "./diyDemandModel.vue?vue&type=style&index=0&id=1f3355c0&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__